"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("../domain");
const renames_1 = require("../../utilities/renames");
class TransactionServiceImpl {
    transactionRepository;
    mathCalculation;
    constructor(transactionRepository, mathCalculation) {
        this.transactionRepository = transactionRepository;
        this.mathCalculation = mathCalculation;
    }
    formatterDate = (data) => {
        const response = new Date(data).toLocaleString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZoneName: 'short',
            timeZone: 'America/Lima',
        });
        const result = `${response.substr(3, 2)}/${response.substr(0, 2)}/${response.substr(6, 4)}`;
        return result;
    };
    async approvalTransaction({ transactionId, status, customer, }) {
        return this.transactionRepository.approvalTransaction(transactionId, status, customer);
    }
    calculateTaxes({ costBasis, totalShares, withdrawalOfMoney, withdrawalOfShares, rescueType, }) {
        const costBasisUnit = this.mathCalculation.divide(costBasis, totalShares, {
            precision: 12,
        });
        const newCostBasis = this.mathCalculation.multiply(costBasisUnit, withdrawalOfShares, { precision: 12 });
        const earnings = this.mathCalculation.subtract(withdrawalOfMoney, rescueType === domain_1.RescueType.PARTIAL ? newCostBasis : costBasis, { precision: 12 });
        let taxes = 0;
        if (earnings > 0) {
            taxes = this.mathCalculation.multiply(earnings, 0.05, { precision: 12 });
        }
        return taxes;
    }
    async subscribe(params) {
        return this.transactionRepository.subscribe({
            ...params,
            blumAnalyticsId: params.blumAnalyticsId || '',
        });
    }
    async rescue(data) {
        return this.transactionRepository.rescue(data);
    }
    async fundSwitch(data) {
        return this.transactionRepository.fundSwitch(data);
    }
    async findTransactions({ onlyInProgress = false, goalId = '', filters, }) {
        const params = {
            onlyInProgress: onlyInProgress ? 'true' : 'false',
            ...(goalId && { goalId }),
            ...(filters && {
                filters: Object.fromEntries(Object.entries(filters).filter(([_, value]) => value)),
            }),
        };
        const dataTransactions = await this.transactionRepository.findTransactions(params);
        const transactions = dataTransactions.map((transaction) => {
            return {
                ...transaction,
                creationDateFormat: this.formatterDate(transaction?.creationDate),
                fund: {
                    id: transaction.fund?.id ||
                        transaction?.destiny?.goal?.fund?.id ||
                        transaction?.origin?.fund?.id,
                    fundName: (0, renames_1.getFundName)(transaction?.fund?.id ||
                        transaction?.destiny?.goal?.fund?.id ||
                        transaction?.origin?.fund?.id),
                    series: transaction?.fund?.series ||
                        transaction?.destiny?.goal?.fund?.series ||
                        transaction?.origin?.fund?.series,
                    seriesName: (0, renames_1.getSeriesName)(transaction?.fund?.series ||
                        transaction?.destiny?.goal?.fund?.series ||
                        transaction?.origin?.fund?.series),
                },
                origin: {
                    ...(transaction.type === 'BUY' && {
                        buy: { ...transaction.origin },
                    }),
                    ...(transaction.type === 'SELL' && {
                        sell: {
                            goals: transaction?.origin?.fund?.goals ||
                                transaction?.origin?.goals ||
                                [],
                        },
                    }),
                },
                destiny: {
                    ...(transaction?.type === 'BUY' && {
                        buy: {
                            ...(transaction.destiny?.goal && {
                                goal: {
                                    id: transaction.destiny.goal.id,
                                },
                            }),
                        },
                    }),
                    ...(transaction?.type === 'SELL' && {
                        sell: {
                            accountId: transaction?.destiny?.account?.id,
                        },
                    }),
                },
                statusName: renames_1.TransactionStatusName[transaction?.status],
                typeName: renames_1.transactionTypeName[transaction?.type],
            };
        });
        return transactions;
    }
}
exports.default = TransactionServiceImpl;
//# sourceMappingURL=TransactionServiceImpl.js.map